import { render } from "./_Accessibility.vue?vue&type=template&id=d8fa6f8a&scoped=true&lang=en"
import script from "./_Accessibility.vue?vue&type=script&lang=js"
export * from "./_Accessibility.vue?vue&type=script&lang=js"

import "./_Accessibility.vue?vue&type=style&index=0&id=d8fa6f8a&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fa6f8a"]])

export default __exports__